<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="7">
        <b-card>
          <div slot="header">
            <strong>확정안 다운로드</strong> <small></small>
          </div>
          <b-row>
            <b-col sm="2">
              <select id="startDate" class="form-control" v-model="formData.gubun">
                <option>Reach</option>
                <option>ReachCurve</option>
              </select>
            </b-col>
            <b-col sm="2">
              <select id="startDate" class="form-control" v-model="selectedMonthly" v-on:change="selectedOption">
                <option>월별</option>
                <option>전체</option>
              </select>
            </b-col>
            <b-col sm="3" v-show="formData.monthly">
              <select id="startDate" class="form-control"  v-model="formData.startDate">
                <option v-for="(date_obj, date) in dateList" :value="date_obj.date_cd">{{date_obj.date_nm}}</option>
              </select>
            </b-col>
            <b-col sm="3" v-show="formData.monthly">
              <select id="endDate" class="form-control" v-model="formData.endDate">
                <option v-for="(date_obj, date) in dateList" :value="date_obj.date_cd">{{date_obj.date_nm}}</option>
              </select>
            </b-col>
            <b-col sm="2">
              <b-button block variant="outline-primary" class="btn-pill" @click="excelDown()">
                <span style="font-weight:900;">엑셀 다운</span>
              </b-button>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="12">
              <b-progress v-if="showProgressBar" :value="counter" :max="max" show-progress animated></b-progress>
              <div v-if="showErrMessage" class="errorMessage"> 서버에러 발생 </div>
            </b-col>
          </b-row>
          <div slot="footer">

          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const moment = require("moment");

import swal from 'sweetalert2'
// const swal = require('sweetalert2')

export default {
  data(){
    return {
      showErrMessage:false,
      showProgressBar:false,
      counter:0,
      max:100,
      selectedMonthly : '월별',
      validateResult : false,
      formData:{
        gubun : 'Reach',
        startDate:'2019-01',
        endDate:'2019-02',
        monthly : true,
      },
      dateList:[
        {'date_nm' : '2018년08월', 'date_cd' : '2018-08'},
        {'date_nm' : '2018년09월', 'date_cd' : '2018-09'},
        {'date_nm' : '2018년10월', 'date_cd' : '2018-10'},
        {'date_nm' : '2018년11월', 'date_cd' : '2018-11'},
        {'date_nm' : '2018년12월', 'date_cd' : '2018-12'},
        {'date_nm' : '2019년01월', 'date_cd' : '2019-01'},
        {'date_nm' : '2019년02월', 'date_cd' : '2019-02'},
        {'date_nm' : '2019년03월', 'date_cd' : '2019-03'},
        {'date_nm' : '2019년04월', 'date_cd' : '2019-04'},
        {'date_nm' : '2019년05월', 'date_cd' : '2019-05'},
        {'date_nm' : '2019년06월', 'date_cd' : '2019-06'},
        {'date_nm' : '2019년07월', 'date_cd' : '2019-07'},
        {'date_nm' : '2019년08월', 'date_cd' : '2019-08'},
        {'date_nm' : '2019년09월', 'date_cd' : '2019-09'},
        {'date_nm' : '2019년10월', 'date_cd' : '2019-10'},
        {'date_nm' : '2019년11월', 'date_cd' : '2019-11'},
        {'date_nm' : '2019년12월', 'date_cd' : '2019-12'},
      ]
    }
  },
  created: function() {

  },
  mounted: function() {
    // this.createSelectFn(this);
    // swal('Any fool can use a computer')
  },
  watch: {
    'formData.startDate': function(){
      this.calcDiffMonth();
    },
    'formData.endDate': function(){
      this.calcDiffMonth();
    }
  },
  methods: {
    calcDiffMonth(){
      var startArr = this.formData.startDate.split('-');
      var endArr = this.formData.endDate.split('-');

      var date1 = new Date(startArr[0], startArr[1]);
      var date2 = new Date(endArr[0], endArr[1]);
      this.validateResult = date1<=date2 ? true:false;
      if(!this.validateResult){
        alert('[년월]을 다시선택하세요');
      }
    },
    selectedOption(){
      if(this.selectedMonthly == '월별'){
        this.formData.monthly = true;
      }else{
        this.formData.monthly = false;
      }
    },
    excelDown(){
      this.showErrMessage = false;
      this.showProgressBar = true;
      this.counter = 20;

      this.calcDiffMonth();
      if(this.validateResult){
        var token = sessionStorage.getItem("myToken");
        var param = JSON.stringify(this.formData);
        var data = new FormData();
        data.append('objs', param);
        var config = {
          responseType: 'blob'
        };

        this.$http.post('/excel/campaignInfoListExcelDown' + this.formData.gubun ,data,config)
          .then((result) => {
          this.counter = 50;
          // console.log(result);
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = url;
          var fileName = "확정안리스트";
          fileName = fileName + "_" + moment().format('YYYYMMDD') ;
          link.setAttribute('download', fileName + '.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.counter = 100;

          var self = this;
          setTimeout(function(){
            self.showProgressBar = false;
            self.counter = 0;
          }, 2000);
        })
        .catch(error => {
            console.log(error.response)
            this.showProgressBar = false;
            this.showErrMessage = true;
        });
      }
    }
  }
}
</script>
<style src="select2/dist/css/select2.min.css"></style>
<style src="select2-bootstrap-theme/dist/select2-bootstrap.min.css"></style>
<style scoped>

.errorMessage{
  font-weight: 900;
  color : #990000;
}

</style>



// WEBPACK FOOTER //
// src/views/management/CampaignInfo/CampaignInfoList.vue